import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

import { useAuth } from "@/lib/auth";

// TNK-177 — root landing. The public face is the storefront; operators enter
// through a separate door (see DoorResolver in __root.tsx). So `/` just routes:
// once auth resolves, a signed-in operator goes to their dashboard, everyone
// else to the store. Rendered outside the operator chrome via the `/` exemption
// in __root.tsx, so an unauth visitor never sees the login here.
export const Route = createFileRoute("/")({
  component: IndexRedirect,
});

function IndexRedirect() {
  const auth = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (auth.isLoading) return; // wait for /api/auth/me so we pick the right door
    void navigate({
      to: auth.isAuthenticated ? "/dashboard" : "/shop",
      replace: true,
    });
  }, [auth.isLoading, auth.isAuthenticated, navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Loading…</p>
    </div>
  );
}
